import React, { Component } from 'react';
import Translation from "../../../../shared/Translation";

export default class ConfirmationHeader extends Component {
    render() {
        return (
            <div className="confirmation-header">
                <div className="confirmation-heading">
                    <div className="confirmation-header__check">
                        <span className="icon-check" aria-hidden="true"></span>
                    </div>
                    <div className="confirmation-header__text">
                        <h1 id='confirmation-page-header' className="confirmation-header__success"><Translation>{!!this.props.pending ? 'checkout__thank_you_for_your_order' : 'checkout__successful_reservation'}</Translation></h1>
                    </div>
                </div>
                <div className="confirmation-header__content">
                    {this.props.children}
                </div>
            </div>
        )
    }
}
